import { useRouter } from 'next/router';
import * as React from 'react';

import { SimpleEventTabsLayout } from '../layouts/SimpleEventTabsLayout';
import { SimpleEventRegistrants } from './components/SimpleEventRegistrants';

export const SimpleEventRegistrantsPage: React.FC = () => {
  const router = useRouter();
  const eventId = router.query.eventId.toString();

  return (
    <SimpleEventTabsLayout eventId={eventId}>
      <SimpleEventRegistrants eventId={eventId} />
    </SimpleEventTabsLayout>
  );
};
